import {mapActions, mapGetters, mapMutations} from "vuex";
import {StatisticsFilters} from "./components/statistics-filters";
import {SalesDataTable} from "./components/sales-data-table";
import {TransactionsBar} from "./components/transactions-bar";
import {TransactionsPie} from "./components/transactions-pie";
import {ActionsTable} from "./components/actions-table"

export default {
  components: {
    StatisticsFilters,
    SalesDataTable,
    TransactionsBar,
    TransactionsPie,
    ActionsTable,
  },
  data: () => ({
    activeFilters: {}
  }),
  computed: {
    ...mapGetters('user', ['role']),
    hasFullAccess() {
      return this.role === 'ADMIN' || this.role === 'SALESADMIN'
    }
  },
  methods: {
    ...mapMutations('statistics', ['resetState']),
    ...mapActions('statistics', ['refetchStatistics', 'refetchActions', 'refetchGraphs']),
    onFilterUpdate(params) {
      this.activeFilters = params;

      void this.refetchStatistics(params);

      if (this.hasFullAccess) {
        void Promise.all([
          this.refetchActions(params),
          this.refetchGraphs(params)
        ])
      }
    }
  },
  beforeDestroy() {
    this.resetState()
  }
}